"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapacitySchema = void 0;
const joi_1 = __importDefault(require("joi"));
const geography_1 = require("../utility/geography");
const mongo_1 = require("../utility/mongo");
exports.CapacitySchema = joi_1.default.object({
    _id: mongo_1.ObjectIdSchema,
    createdAt: joi_1.default.date(),
    updatedAt: joi_1.default.date(),
    start: joi_1.default.date().required(),
    end: joi_1.default.date().required(),
    googleCalendarId: joi_1.default.string().required(),
    googleEventId: joi_1.default.string().required(),
    location: joi_1.default.object({
        address: joi_1.default.string().required(),
        geometry: geography_1.PointSchema.required()
    }).required(),
    status: joi_1.default.string().allow('confirmed', 'cancelled').required(),
    // TODO: get rid of this one in favor of photographerUuid
    photographerId: mongo_1.ObjectIdSchema.required(),
    uuid: joi_1.default.string().uuid().required()
}).meta({ className: 'Capacity' });
//# sourceMappingURL=CapacitySchema.js.map